// @flow

import { createSelector } from 'reselect';

import {
  selectProducts,
  type DecoratedProduct,
  type ProductId,
} from '@gandi/cart';

import type { FullState } from '../../types';

export type SelectMailboxProductById = {
  id: ProductId,
};

export const selectMailboxProductById: (
  FullState,
  SelectMailboxProductById,
) => void | DecoratedProduct = createSelector(
  selectProducts,
  (_state, props) => props,
  (products: Array<DecoratedProduct>, props: SelectMailboxProductById) =>
    products.find(product => product.id === props.id),
);
